// src/data/formOptions.js
// Centralised dropdown option lists shared across all forms.

export const SEVERITY_OPTIONS = [
  'Sev-0 (Critical)',
  'Sev-1 (High)',
  'Sev-2 (Medium)',
  'Sev-3 (Low)',
];

export const PRIORITY_OPTIONS = [
  'Highest',
  'High',
  'Medium',
  'Low',
  'Lowest',
];

export const SOURCE_OPTIONS = [
  'Business Team',
  'Technical Team',
];

// Fallback list — used by useImpactedModules hook when the Nocobase API is unavailable.
// The primary data source is the /impactedModules:list API endpoint.
export const IMPACTED_MODULES = [
  'Marketplace',
  'Dealer+',
  'Underwriter UI',
  'Acquire',
  'Proviner',
  'AFS Middleware',
  'Acquire Middleware',
  'Origination Service',
  'Dealerplus Zoho',
  'TalentChek',
  'Inventory Service',
  'User Service',
  'API Gateway',
  'Dealer Service',
  'Leddi Prime',
  'Leddi Nest',
  'Leddi Paper',
  'Leddi Mist',
  'Leddi X',
  'Hydra',
  'Hydra Gen',
  'FleetZen',
  'Inspection App',
  'Jira',
  'Confluence',
  'Nova Engine',
  'Sales Management Tool',
  'VFD Liquidation Portal',
  'Bank App',
  'Legal+',
  'VO+',
];

export const COUNTRIES = [
  'Kenya',
  'Uganda',
  'Nigeria',
  'Ghana',
  'Senegal',
  'South Africa',
  'Ivory Coast',
  'Morocco',
  'Egypt',
  'USA',
  'Other',
];

export const PRODUCTS = [
  'Car4Cash',
  'Finance loan',
  'Dealer Finance',
  'Equity release',
  'Dealer White label',
  'Ride hailing',
  'Other',
];

export const PLATFORMS = [
  'Marketplace',
  'Dealer+',
  'Underwriter UI',
  'Acquire',
  'Proviner',
  'AFS Middleware',
  'Acquire Middleware',
  'Origination Service',
  'Dealerplus Zoho',
];
